/* @ngInject */
const sterileFormat = (utils) => {
  const self = {}

  self.server = (_sterile) => {
    const sterile = utils.copy(_sterile)

    return sterile
  }

  self.user = (_sterile) => {
    const sterile = utils.copy(_sterile)

    return sterile
  }

  return self
}
export default sterileFormat



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/services/format.service.js